<template>
    <div>

        <v-btn small depressed fab class="mx-2 morebtn-hover" @click="routerPush(click)" color="#FF5100" :disabled="disable">
            <v-icon class="white--text">add</v-icon>
        </v-btn>
        <span v-if="disable" style="user-select: none">
            {{$t('seeMore')}}
        </span>
        <span v-else style="user-select: none;cursor: pointer" @click="routerPush(click)">
            {{$t('seeMore')}}
        </span>

    </div>
</template>

<script>
    import { mapActions,mapState } from 'vuex';

    export default {
        name: "SeeMore",
        props: ['disable','click'],
        methods: {
            ...mapActions('searchedChart',['searchedDataIndustry','setIndustryType','searchedAllIndustryByYear','setLoadState']),
            routerPush(path) {
                switch (path.type) {
                    case 'push':
                        this.$router.push(path.path);
                        break;
                    case 'url':
                        window.open(path.url);
                        break;
                    case 'search':
                        this.setLoadState(false);
                        this.searchedDataIndustry(path.data).then(() => {
                            setTimeout(() => {
                                this.setIndustryType(false);
                                this.setLoadState(true);
                                this.$router.push('/industries');
                            },300);
                        });
                        break;
                    case 'searchall':
                        this.setLoadState(false);
                        this.searchedAllIndustryByYear(path.data.year).then(() => {
                            setTimeout(() => {
                                this.searchedData.id = "ทั้งหมด";
                                this.setIndustryType(true);
                                this.setLoadState(true);
                                this.$router.push('/industries');
                            },300);
                        });
                        break;
                }
            }
        },
        computed: {
            ...mapState({
                searchedData: state => state.searchedChart.industrySearched
            })
        }
    }
</script>

<style scoped>
    .morebtn-hover:hover {
        -webkit-animation: spin .4s linear;
    }
    .morebtn-hover {
        -webkit-animation: revertspin .4s linear;
    }

    @-webkit-keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(180deg);
        }
    }
    @-webkit-keyframes revertspin {
        from {
            transform:rotate(180deg);
        }
        to {
            transform:rotate(0deg);
        }
    }
</style>
